"use strict";
/**
 * Model of https://developers.google.com/android/reference/com/google/android/gms/maps/model/LatLng
 */
Object.defineProperty(exports, "__esModule", { value: true });
function isEqual(a, b) {
    return a.latitude === b.latitude && a.longitude == b.longitude;
}
exports.isEqual = isEqual;
